"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var dsSearchUsersController = /** @class */ (function () {
    function dsSearchUsersController(UsersModel, FlashService, $timeout) {
        this.users = [];
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.$timeout = $timeout;
        this.searching = false;
        this.oldPlaceolder = this.placeholder;
        this.search = (0, lodash_1.debounce)(this.search, 1000);
        this.focusOnSearchField = this.focusOnSearchField.bind(this);
    }
    dsSearchUsersController.prototype.focusOnSearchField = function (isOpen) {
        if (isOpen) {
            this.placeholder = "Search by name, email or phone.";
            var el_1 = document
                .getElementById("admin-header-user-search-wrapper")
                .querySelector("input[type=search]");
            this.$timeout(function () {
                el_1.focus();
            }, 200);
        }
        else {
            this.placeholder = this.oldPlaceolder;
        }
    };
    /**
     * Search for students by name
     * @param search
     */
    dsSearchUsersController.prototype.search = function (search) {
        var _this = this;
        if (!search) {
            return;
        }
        var searchParams = {};
        //this.searching = false;
        this.FlashService.clearFlash();
        searchParams.query = search;
        if (typeof searchParams.query === "undefined") {
            return;
        }
        if (typeof this.userType !== "undefined") {
            searchParams.user_type = encodeURI(this.userType);
        }
        searchParams.toggleStudentSchoolOverride = this.schooloverride;
        this.searching = true;
        var placeholder = this.placeholder;
        this.placeholder = "";
        this.UsersModel.searchUsers(searchParams).then(function (response) {
            _this.users = response.data;
            _this.searching = false;
            _this.placeholder = placeholder;
        });
    };
    return dsSearchUsersController;
}());
dsSearchUsersController.$inject = ["UsersModel", "FlashService", "$timeout"];
exports.default = dsSearchUsersController;
